import { useMutation, useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'constants/endpoints';
import { get, handleError, handleResponse, post } from './base.service';
import toast from 'react-hot-toast';

export const useGetJobAssessmentQuery = (id: string = '', checkError: boolean = true) =>
	useQuery({
		queryFn: async () => {
			try {
				const response: any = await get(`${API_ENDPOINTS.GET_ASSESSMENTS}/${id}`);

				if (!response?.success && checkError) {
					toast.error(response?.message);
					return {
						isError: true,
					};
				}
				return checkError ? handleResponse(response) : response;
			} catch (err: any) {
				handleError(err);
			}
		},
		queryKey: ['job-assessment-list', id],
		enabled: !!id,
	});

export const useUserSaveAssessmentMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.GET_ASSESSMENT_SAVE, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useSaveJobQuestionnaireMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.SAVE_ASSESSMENT, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});
